
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.168 10.03C5.65 6.888 8.441 4.5 11.786 4.5c2.66 0 4.964 1.508 6.042 3.7 2.576.06 4.672 2.104 4.672 4.65 0 2.583-2.158 4.65-4.786 4.65-.146 0-.291-.006-.434-.019h-5.148a6.953 6.953 0 01-.692 0H5.334c-2.102 0-3.834-1.653-3.834-3.727 0-2.02 1.642-3.64 3.668-3.725zm6.618-4.53c-3.01 0-5.455 2.25-5.675 5.076a.5.5 0 01-.538.46 2.992 2.992 0 00-.24-.01c-1.58 0-2.833 1.236-2.833 2.728 0 1.491 1.253 2.728 2.834 2.728h.058l.01-.001h6.051a6.023 6.023 0 00.666 0h5.183a3.977 3.977 0 00.411.019c2.107 0 3.787-1.65 3.787-3.65 0-2.001-1.68-3.65-3.786-3.65-.061 0-.122 0-.182.004a.5.5 0 01-.483-.303C16.2 6.91 14.17 5.5 11.786 5.5z","fill":"#88A9FF"}})])
          )
        }
      }
    